import React from 'react';

const LocationIcon = ({ size = 22, title = 'Location pin' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    role="img"
    aria-label={title}
    focusable="false"
  >
    <path d="M12 2C8.134 2 5 5.134 5 9c0 5.408 5.898 12.169 6.151 12.461a1 1 0 0 0 1.498 0C13.902 21.169 19 14.408 19 9c0-3.866-3.134-7-7-7zm0 17.145C10.094 16.392 7 11.678 7 9c0-2.757 2.243-5 5-5s5 2.243 5 5c0 2.678-3.094 7.392-5 10.145z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

export default LocationIcon;




